import React, { createContext, useContext } from 'react';
import { NamedDisclaimer } from '../helpers/disclaimers/disclaimers-utils';
import { cleanText } from '../helpers/common-helpers';

interface DisclaimersContextValue {
	allDisclaimers: NamedDisclaimer[];
	findBadge: (legalText: string | null | undefined) => string | undefined;
}

const DisclaimersContext = createContext<DisclaimersContextValue>({
	allDisclaimers: [],
	findBadge: () => undefined,
});

export const DisclaimersProvider: React.FC<{
	allDisclaimers: NamedDisclaimer[];
	children: React.ReactNode;
}> = ({ allDisclaimers, children }) => {
	const findBadge = (legalText: string | null | undefined): string | undefined => {
		if (!legalText || !allDisclaimers.length) return undefined;
		const clean = cleanText(legalText);
		const found = allDisclaimers.find((d) => cleanText(d.text) === clean);
		return found ? found.ref.replace(/\.$/, '') : undefined;
	};

	return <DisclaimersContext.Provider value={{ allDisclaimers, findBadge }}>{children}</DisclaimersContext.Provider>;
};

export const useDisclaimers = () => {
	const context = useContext(DisclaimersContext);
	if (!context) {
		throw new Error('useDisclaimers must be used within a DisclaimersProvider');
	}
	return context;
};
